import { toast } from '@crosscode/gravity-components'

export function copyIpToClipboard(ip?: string) {
  if (!ip) return
  void navigator.clipboard?.writeText(ip)
  toast.success('IP скопирован')
}
